import { clientAxios } from "@/plugins/axios";

export const DashboardService = (payload = null) => {
  return clientAxios.get(`/dashboards/token/${payload}`);
};
